import React from "react";
import FormComponent from "../components/FormComponent";

function Banner() {
  return (
    <section id="banner" className="position-relative">
      <div className="container-lg px-md-0 px-lg-3">
        <div className="row g-0 justify-content-between">
          <div className="col-md-7 col-xl-7 position-relative z-3 banner-wrapper">
            <div className="bannerlist mt-3 px-md-3 px-xl-0">
              <h1>
                Fulfil your dreams with a <br />
                <span>Personal Loan on your Credit&nbsp;Card</span>
              </h1>
              <div className="ban_wrap d-flex">
                <div className="top_ben mt-3">
                  <div className="ben_wrap d-flex gap-2 justify-content-center align-items-center mt-0">
                    <img
                      src="dist/img/icons/icon03.svg"
                      alt="icon"
                      width={35}
                      height={35}
                    />
                    <p>Loan of up to ₹20 lakh</p>
                  </div>
                  <div className="ben_wrap d-flex gap-2 justify-content-center align-items-center">
                    <img
                      src="dist/img/icons/icon02.svg"
                      alt="icon"
                      width={35}
                      height={35}
                    />
                    <p>Quick disbursal* </p>
                  </div>
                  <div className="ben_wrap d-flex gap-2 justify-content-center align-items-center">
                    <img
                      src="dist/img/icons/icon01.svg"
                      alt="icon"
                      width={35}
                      height={35}
                    />
                    <p>No documentation</p>
                  </div>
                  <p className="ban_tnc">*For Savings Account holders</p>
                </div>
                <img
                  src="dist/img/banner_mobile.webp"
                  alt=""
                  className="img-fluid d-md-none ban_mob"
                  width={170}
                  height={330}
                />
                <img
                  src="dist/img/banner_desktop.webp"
                  alt=""
                  className="img-fluid d-none d-md-block ban_desk"
                  width={300}
                  height={535}
                />
              </div>
            </div>
          </div>
          <div className="col-md-5 col-xl-4 pe-md-3 pe-lg-0">
            <FormComponent></FormComponent>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
